export const ExpenseValidationScheema = (json, isEditMode) => {

    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

        if (json?.title === undefined || json?.title === '') {
            Object.assign(errorJson, { title: "Expense title cannot be empty *" });
        }

        if (json?.amount === undefined || json?.amount === '') {
            Object.assign(errorJson, { amount: "Amount cannot be empty *" });
        }
        if (json?.amount?.length > 0 || json?.amount) {
            const amount = parseFloat(json.amount);
            if (isNaN(amount) || amount <= 0) {
                Object.assign(errorJson, { amount: "Amount must be a valid positive number *" });
            }
        }

        if (json?.date === undefined || json?.date === '') {
            Object.assign(errorJson, { date: "Date cannot be empty *" });
        }

        if (json?.category === undefined || json?.category === '') {
            Object.assign(errorJson, { category: "Category selection is required *" });
        }

        if (json?.paymentMethod === undefined || json?.paymentMethod === '') {
            Object.assign(errorJson, { paymentMethod: "Payment method selection is required *" });
        }

        if (json?.reimbursement === undefined || json?.reimbursement === '') {
            Object.assign(errorJson, { reimbursement: "Reimbursement selection is required *" });
        }

        if (json?.proofUrl === undefined || json?.proofUrl === '') {
            Object.assign(errorJson, { proofUrl: "Expense proof is required *" });
        }

        resolve(errorJson);
    })
    return MyPromise;
}
